import { H4 } from 'components/headings';
import Layout from 'components/layout';
import SEO from 'components/seo';
import ContentSection from 'components/ui/content-section';
import { Text } from 'components/ui/text';
import { useSiteSettings } from 'hooks/use-siteSettings';
import { GetStaticProps } from 'next';
import Link from 'next/link';
import { backgroundImages } from 'utils/config';
import APP_ROUTES from 'utils/routes';

// Reference: https://nextjs.org/docs/advanced-features/custom-error-page

export default function Custom404() {
  const { siteSettings } = useSiteSettings();

  return (
    <Layout mainBackground={backgroundImages.treesBurn}>
      <SEO
        title={`Page not found | ${siteSettings.title}`}
        description={siteSettings.description}
      />
      <ContentSection>
        <H4 as='h1'>404 - Page Not Found</H4>
        <Text>
          We can't seem to find the page you're looking for. It may be because
          we have recently updated our website and some content has been moved
          or deleted.
        </Text>
        <Text>
          Return to{' '}
          <Link href={APP_ROUTES.home}>
            <a>Home</a>
          </Link>
          .
        </Text>
      </ContentSection>
    </Layout>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};
